import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { OrderFormat, OutletListItem } from '@ancon/wildcat-types'
import getOutletOrderPreparationTime from '@ancon/wildcat-utils/outlet/getOutletOrderPrepTime'
import getTimeSpanParts from '@ancon/wildcat-utils/time/getTimeSpanParts'
import clsx from 'clsx'

import BodyText from '../../app/components/BodyText'

import styles from './OutletOrderPreparationTimeTag.module.scss'

type OutletOrderPreparationTimeTagProps = {
  orderFormat: OrderFormat | null
  outlet?: OutletListItem | null
  className?: string
}

export default function OutletOrderPreparationTimeTag({
  orderFormat,
  outlet,
  className,
}: OutletOrderPreparationTimeTagProps) {
  const { t } = useTranslation('common')

  const preparationTime = getOutletOrderPreparationTime(outlet!, orderFormat!)

  function getFormattedPreparationTime(prepTime: string) {
    const preparationTimeSpanParts = getTimeSpanParts(prepTime)

    const { hours, minutes } = preparationTimeSpanParts

    const hourLabel = t('time.hourShort')
    const minuteLabel = t('time.minuteShort')

    if (hours > 0) {
      if (minutes > 0) {
        return `${hours} ${hourLabel} ${minutes} ${minuteLabel}`
      }

      return `${hours} ${hourLabel}`
    }

    return `${minutes} ${minuteLabel}`
  }

  if (!preparationTime) {
    return null
  }

  return (
    <div className={clsx(styles.container, className)}>
      <BodyText as="span" color="body-1">
        {t('order.preparationTime', {
          time: getFormattedPreparationTime(preparationTime),
        })}
      </BodyText>
    </div>
  )
}
